/**
 * @deprecated use XlibApplication.js (docs/xlib-application-bootstrap.md) —
 *   `data-element` discovery and lazy `() => import()` registration instead of
 *   the `[is-element-*]` attribute scan, which has 0 hits in this project.
 * @see Consumers 2026-08-06: web-reichweiten, wp-cosi, wp-epaper, wp-premium,
 *   wp-shop-digitalphoto, wp-shop-fmm, wp-stoffwechsel-turbo. Removable when
 *   this list is empty.
 */
export default class Application {
    static configure(config) {
        if (Array.isArray(config.Elements)) {
            console.log('Warning: please use associative Elements with HTML attributes as keys');

            let elementsByAttributes = {};
            config.Elements.forEach((xlibElement) => {
                const elementAtttibute = this.elementClassNameToAttribute(xlibElement.name);
                elementsByAttributes[elementAtttibute] = xlibElement;
            });
            config.Elements = elementsByAttributes;
        }
        this.config = config;
    }

    static elementClassNameToAttribute(importName) {
        const elementClassName = importName.split(/_/)[1] ? importName.split(/_/)[1] : importName;
        const elementFileName = elementClassName.replace(/Element$/, '');
        return 'is-element-'+ elementFileName.split(/(?=[A-Z])/).join('-').toLowerCase();
    }

    static start() {
        if (document.readyState === 'complete') {
            Application.loadElements(document.body);
            return;
        }
        document.addEventListener('DOMContentLoaded', () => Application.loadElements(document.body));
    }

    static loadElements(ref) {
        const possibleElements = ref.querySelectorAll('[is-element]');

        for (let i = 0; i < possibleElements.length; i++) {
            const possibleElement = possibleElements[i];

            if (possibleElement.attributes['is-initialized']) {
                console.warn('Element was already initialized.');
                continue;
            }

            for (let j = 0; j < possibleElement.attributes.length; j++) {
                const attribute = possibleElement.attributes[j];

                if (attribute.name.match(/^is-element-/i)) {
                    const elementClass = Application.getElementFromAttributeName(attribute.name);

                    if (elementClass) {
                        let config = attribute.value || '{}';
                        try {
                            config = decodeURIComponent(config);
                            config = JSON.parse(config);
                        } catch (e) {
                            config = {};
                            console.error("Failed to parse config for " + elementClass.name);
                        }
                        new elementClass(config, possibleElement);
                    }
                }
            }
        }
    }

    static getElementFromAttributeName(elementAttribute) {
        if (this.config.Elements[elementAttribute]) {
            return this.config.Elements[elementAttribute];
        } else {
            console.error('No element for found for attribute ' + elementAttribute);
            return null;
        }

    }
}
